import { getInMilliseconds } from 'app/shared/helpers/getInMilliseconds';
import { Seconds } from 'app/shared/types/Seconds.type';

export async function delay(seconds: Seconds) {
  const timeout = getInMilliseconds(seconds);
  // return await for better async stack trace support in case of errors.
  return await new Promise((resolve) => setTimeout(resolve, timeout));
}
